'use client';

import { c } from '../../../utils/tailwind-merge';
import { CheckboxV2 } from '../../atoms/Checkbox.v2';
import type { CheckboxWithLabelProps } from './CheckboxWithLabel.types';

export function CheckboxWithLabel({
  id,
  checked,
  defaultChecked,
  disabled = false,
  count,
  microcopy,
  onCheckedChange,
  className,
}: CheckboxWithLabelProps): React.JSX.Element {
  return (
    <div
      className={c(
        'group flex min-h-10 w-full items-center gap-3 rounded-lg px-1 py-1 transition-colors',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-grey-100',
        className
      )}
    >
      <CheckboxV2
        id={id}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
      />
      <label
        htmlFor={id}
        className={c(
          'flex flex-1 cursor-pointer items-center gap-3 text-base leading-6 tracking-tight',
          disabled
            ? 'cursor-not-allowed text-grey-450'
            : 'text-grey-900 group-has-[button[data-state=checked]]:font-medium'
        )}
      >
        <span className="flex-1">{microcopy.label}</span>
        {/* TODO: Extract CountBadge as a shared atom (also used in TreeAccordion) */}
        {count !== undefined && (
          <span className="rounded bg-grey-100 px-1 text-xs leading-5 tracking-tight text-grey-700">
            {count.toLocaleString()}
          </span>
        )}
      </label>
    </div>
  );
}
